import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { setActiveOverlayInfo } from 'current';
import {
  setIsOverlaySelectModalActive,
  setIsOverlayQuickSelectActive,
  setSelectedOverlayLayerWithDefaults
} from 'current/uiwidgets';
import {
  getActiveOverlayLayer,
  getActiveScriptType
} from 'current/selectors';
import { getOverlayQuickSelectMenuOptions } from 'imagery/selectors';

import OverlayQuickLayerSelect from 'mapping/OverlayQuickLayerSelect';

let OverlayQuickSelectMenuContainer = ({
  menuOptions,
  scriptType,
  selectedLayer,
  onChangeOverlay,
  setIsModalActive
}) => {
  return (
    <div>
      <OverlayQuickLayerSelect
        menuOptions={menuOptions}
        onChangeOverlay={onChangeOverlay}
        scriptType={scriptType}
        selectedLayer={selectedLayer}
        setIsModalActive={setIsModalActive}
      />
    </div>
  );
};

OverlayQuickSelectMenuContainer.propTypes = {
  menuOptions: PropTypes.arrayOf(PropTypes.shape({
    layer: PropTypes.string.isRequired,
    overlayUuid: PropTypes.string.isRequired,
    season: PropTypes.string,
    cropId: PropTypes.number
  })),
  onChangeOverlay: PropTypes.func.isRequired,
  scriptType: PropTypes.string.isRequired,
  selectedLayer: PropTypes.string,
  setIsModalActive: PropTypes.func.isRequired
};

OverlayQuickSelectMenuContainer = connect(
  (state) => {
    return {
      menuOptions: getOverlayQuickSelectMenuOptions(state),
      scriptType: getActiveScriptType(state),
      selectedLayer: getActiveOverlayLayer(state)
    };
  },
  (dispatch) => {
    return {
      onChangeOverlay: ({ layer, season, uuid }) => {
        if (layer === 'more') {
          dispatch(setIsOverlaySelectModalActive(true));
        } else {
          dispatch(setActiveOverlayInfo({ uuid, layer }));
          dispatch(setSelectedOverlayLayerWithDefaults(layer, season));
          dispatch(setIsOverlayQuickSelectActive(false));
        }
      },
      setIsModalActive: (active) => dispatch(setIsOverlaySelectModalActive(active))
    };
  },
)(OverlayQuickSelectMenuContainer);

export default OverlayQuickSelectMenuContainer;
